/** Route to the cross-company To-do overview, relative to the company slug. */
export const TodoOverviewPath = "AllCompanies";

/** Value of the "all companies" entry in the header company selector. Not a company url, so it cannot collide with one. */
export const CompanySelectorValue = "__allCompanies__";

/** How many companies' To-do summaries are in flight at once. Each summary runs every To-do handler in Core for that company. */
export const SummaryConcurrency = 6;

/** How many To-do groups a card lists before the rest collapse into a "+N" indicator. */
export const SummaryGroupLimit = 4;

/** Opening the overview within this time of the last full load shows the cached cards instead of loading again. */
export const RefreshCooldownMs = 3 * 60 * 1000;
